import axios from "axios";
import {toast} from "react-toastify";

export default class ReportsService {

    getReportLinks = () => {
        const url = `/api/auth/reports/getReportLinks`;

        return new Promise<TracLink[]>((resolve, reject) => {
            axios.get(url)
                .then(({ status, data} ) => {
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(new Error('error fetching report links'));
                    }
                });
        });
    };


    getChartData = (selectedChartId: string, selectedQuarter?: string) => {
        // Build query string parameters
        const params = new URLSearchParams({ chartId: selectedChartId });
        if (selectedQuarter) {
            params.append('quarter', selectedQuarter);
        }

        const url = `/api/auth/charts/chartdata?${params.toString()}`;

        return new Promise<any>((resolve, reject) => {
            axios
                .get(url)
                .then(({ status, data }) => {
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(new Error('Error fetching chart data'));
                    }
                })
                .catch(error => reject(error));
        });
    };

    getChartDefinitions = () => {
        const url = `/api/auth/charts/definitions`;

        return new Promise<ChartLink[]>((resolve, reject) => {
            axios.get(url)
                .then(({ status, data} ) => {
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(new Error('error fetching chart selections'));
                    }
                });
        });
    };

    snapshotBaseData = () => {
        const url = `/api/auth/charts/snapshot-base-data`;

        return axios.post(url)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                throw error.response?.data || "Error creating snapshot";
            });
    };

    getLastSnapshot = () => {
        const url = `/api/auth/charts/last-snapshot`;

        return axios
            .post(url)
            .then(response => response.data)
            .catch(error => {
                throw error.response?.data || "Error retrieving last snapshot";
            });
    };

    getReportPageInfo = (report:string) => {
        const url = `/api/auth/reports/${report}/getReportDetails`;

        return new Promise<TracLink>((resolve, reject) => {
            axios.get(url)
                .then(({ status, data} ) => {
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(new Error('error fetching details for report ' + report));
                    }
                });
        });
    };

    getReportData = (report:string) => {
        const url = `/api/auth/reports/${report}`;

        return new Promise<string>((resolve, reject) => {
            axios.get(url)
                .then(({ status, data} ) => {
                    if (status === 200) {
                        resolve(data);
                    } else {
                        reject(new Error('error fetching data for report - ' + report));
                    }
                });
        });
    };
}